import React, { useState, useEffect } from "react";
import "@/App.css";
import ContentMindmap from "./pages/ContentMindmap";
import SEODashboard from "./pages/SEODashboard";
import VideoStudio from "./pages/VideoStudio";
import NewsStudio from "./pages/NewsStudio";
import LoginPage from "./pages/LoginPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  const [currentView, setCurrentView] = useState('content'); // 'content' | 'seo' | 'studio'
  const [user, setUser] = useState(null);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  // Check for existing session on mount
  useEffect(() => {
    const storedUser = localStorage.getItem('stryde_user');
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
      } catch (e) {
        localStorage.removeItem('stryde_user');
      }
    }
    setIsCheckingAuth(false);
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('stryde_user');
    setUser(null);
    setCurrentView('content');
  };

  // Show loading while checking auth
  if (isCheckingAuth) {
    return (
      <div className="min-h-screen bg-[#1A1A2E] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#0070FF] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Show login if not authenticated
  if (!user) {
    return (
      <>
        <LoginPage onLogin={handleLogin} />
        <Toaster position="bottom-right" />
      </>
    );
  }

  return (
    <div className="App">
      {currentView === 'content' && (
        <ContentMindmap
          onNavigateToSEO={() => setCurrentView('seo')}
          onNavigateToStudio={() => setCurrentView('studio')}
          onNavigateToNews={() => setCurrentView('news')}
          user={user}
          onLogout={handleLogout}
        />
      )}
      {currentView === 'seo' && (
        <SEODashboard
          onBack={() => setCurrentView('content')}
          user={user}
          onLogout={handleLogout}
        />
      )}
      {currentView === 'studio' && (
        <VideoStudio
          onBack={() => setCurrentView('content')}
          user={user}
        />
      )}
      {currentView === 'news' && (
        <NewsStudio
          onBack={() => setCurrentView('content')}
          user={user}
        />
      )}
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
